export const Inter = 'Inter'
export const Poppins = `'Poppins', 'Inter'`
